export default __webpack_public_path__ + "de4096eda01ccb2bf70f509a0b98666b.png";